import { render, staticRenderFns } from "./PatientFormComponent.vue?vue&type=template&id=40e524bb"
import script from "./PatientFormComponent.vue?vue&type=script&lang=js"
export * from "./PatientFormComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports